export default () => ({
  kind: "alphabetical",

  sortBy(event, kind) {
    if (event.target.classList.contains("is-active")) return;

    this.kind = kind;

    switch (this.kind) {
      case "alphabetical":
        this.alphabetical();
        break;
      case "amount":
        this.amount();
        break;
      default:
        this.alphabetical();
    }
  },

  alphabetical() {
    let list = document.querySelector(".holding-boxes");

    [...list.children]
      .sort((a, b) => {
        if (a.classList.contains("clear-both")) return;

        return a.dataset.title > b.dataset.title ? 1 : -1;
      })
      .forEach((node) => list.appendChild(node));
  },

  amount() {
    let list = document.querySelector(".holding-boxes");

    [...list.children]
      .sort((a, b) => {
        if (a.classList.contains("clear-both")) return;

        return parseFloat(b.dataset.weight) - parseFloat(a.dataset.weight);
      })
      .forEach((node) => list.appendChild(node));
  },
});
